<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <el-col :lg="8">
        {{ $t("historico-postagem") }} (02/05/2022 à 01/11/2022) <small>({{ total }} registros)</small>
      </el-col>
      <el-col :lg="16" class="right">
        <el-pagination
          class="right"
          :page-size="records"
          background
          @current-change="fetchRecords"
          @size-change="changeSize"
          :current-page.sync="page"
          layout="sizes, prev, pager, next"
          :page-sizes="[
            50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
          ]"
          :total="total"
        ></el-pagination>
      </el-col>
    </div>
    <el-card shadow="hover">
      <HistorySgpDetail ref="sgpDetail" :userType="userType" />
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker
                v-model="ruleForm.range"
                type="daterange"
                align="right"
                unlink-panels
                clearable
                range-separator="à"
                format="dd/MM/yyyy"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              :label="$t('cliente')"
              prop="name"
              v-if="userType !== '2' && userType !== '5'"
            >
              <CustomerList
                v-model="ruleForm.customer"
                v-bind:multiple="true"
              />
            </el-form-item>
            <el-form-item :label="$t('servico')" prop="name">
              <ServicesList v-model="ruleForm.service" :multiple="true" />
            </el-form-item>
            <el-button size="mini" type="info" @click="fetchRecords()">Filtrar</el-button>&nbsp;
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-table
      :data="tableData"
      stripe
      ref="tablePrepost"
      size="mini"
      style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }"
    >
      <el-table-column
        v-if="userType !== '2' && userType !== '5'"
        sortable
        prop="customer"
        label="Cliente"
      >
        <template slot-scope="scope">
          {{ scope.row.data.customerName }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="department"
        label="Departamento"
      >
        <template slot-scope="scope">
          {{ scope.row.data.department }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="name"
        label="Dest. Nome"
      >
        <template slot-scope="scope">
          {{ scope.row.data.destinyName }}
        </template>
      </el-table-column>
      <el-table-column width="160" sortable prop="tag" :label="$t('objeto')">
        <template slot-scope="scope">
          <el-link @click="open(scope.row.data.tag)">{{ scope.row.data.tag }}</el-link
          >&nbsp;
          <i
            class="el-icon-document-copy"
            v-clipboard:copy="scope.row.data.tag"
            @click="copy()"
          ></i>
        </template>
      </el-table-column>
      <el-table-column sortable prop="service" :label="$t('servico')">
        <template slot-scope="scope">
          {{ scope.row.data.service }}
        </template>
      </el-table-column>
      <el-table-column
        prop="postedAt"
        width="110"
        :label="$t('data')"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.postedAt | formatDate }}
        </template>
      </el-table-column>
      <el-table-column width="80">
        <template slot-scope="scope">
          <el-button
            type="info"
            title="Detalhes desse objeto"
            icon="el-icon-more"
            @click="view(scope.$index, scope.row)"
            circle
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>
<script>
import { HistorySgpService } from "@/services/customers/history.sgp.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import moment from "moment";
import "moment/locale/pt-br";
import HistorySgpDetail from "./HistorySgpDetail.vue";

export default {
  name: "HistorySgp",
  components: {
    CustomerList,
    ServicesList,
    HistorySgpDetail,
  },
  data() {
    return {
      records: 50,
      page: 1,
      current: null,
      tableData: [],
      userType: '2',
      total: 0,
      ruleForm: {
        range: [new Date().setDate(new Date().getDate() - 30), new Date()],
        customer: [],
        service: "",
      },
    }
  },
  methods: {
    view(index, record) {
      const vm = this;
      vm.current = record;
      vm.$refs.sgpDetail.open(record);
    },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetchRecords();
    },
    copy() {
      this.$message({
        type: "success",
        message: "Objeto copiado com sucesso",
      });
    },
    open(tag) {
      vm.$router.replace({ name: "objects.sro.tag", params: { tag: tag }, query: { back: 'pre.post'} });
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);

      HistorySgpService.filter(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.service,
        vm.records,
        vm.page,
      )
        .then(async (response) => {
          vm.tableData = response.data;
          vm.total = response.total;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
}
</script>